import { action } from 'typesafe-actions';
import { ActionTypes } from './actionTypes';

// Pantalla de alumnos

export const getAlumnosCursos = (payload) =>
  action(ActionTypes.GET_ALUMNOS_CURSOS, payload);
export const setAlumnosCursos = (payload) =>
  action(ActionTypes.SET_ALUMNOS_CURSOS, payload);
export const getAlumnosCursosCount = (payload) =>
  action(ActionTypes.GET_ALUMNOS_CURSOS_COUNT, payload);
export const setAlumnosCursosCount = (payload) =>
  action(ActionTypes.SET_ALUMNOS_CURSOS_COUNT, payload);
export const getExcelAlumnosCursos = (payload) =>
  action(ActionTypes.GET_EXCEL_ALUMNOS_CURSOS, payload);

export const getAlumnosCurso = (payload) =>
  action(ActionTypes.GET_ALUMNOS_CURSO, payload);
export const setAlumnosCurso = (payload) =>
  action(ActionTypes.SET_ALUMNOS_CURSO, payload);

// Pantalla de cursos

export const getCursos = (payload) => action(ActionTypes.GET_CURSOS, payload);
export const setCursos = (payload) => action(ActionTypes.SET_CURSOS, payload);

export const getCursosCount = (payload) =>
  action(ActionTypes.GET_CURSOS_COUNT, payload);
export const setCursosCount = (payload) =>
  action(ActionTypes.SET_CURSOS_COUNT, payload);

export const getExcelCursos = (payload) =>
  action(ActionTypes.GET_EXCEL_CURSOS, payload);

export const getSociedadesCursos = (payload) =>
  action(ActionTypes.GET_SOCIEDADES_CURSOS, payload);
export const setSociedadesCursos = (payload) =>
  action(ActionTypes.SET_SOCIEDADES_CURSOS, payload);

export const getProvinciasCursos = (payload) =>
  action(ActionTypes.GET_PROVINCIAS_CURSOS, payload);
export const setProvinciasCursos = (payload) =>
  action(ActionTypes.SET_PROVINCIAS_CURSOS, payload);

export const getEstadosCursos = (payload) =>
  action(ActionTypes.GET_ESTADOS_CURSOS, payload);
export const setEstadosCursos = (payload) =>
  action(ActionTypes.SET_ESTADOS_CURSOS, payload);

export const getCursosFilter = (payload) =>
  action(ActionTypes.GET_CURSOS_FILTER, payload);
export const setCursosFilter = (payload) =>
  action(ActionTypes.SET_CURSOS_FILTER, payload);

export const removeCursosFilter = () =>
  action(ActionTypes.REMOVE_CURSOS_FILTER);

export const setEstadoCurso = (payload) =>
  action(ActionTypes.SET_ESTADO_CURSO, payload);

// Cursos cierre
export const getReportCoursesClosing = (payload) =>
  action(ActionTypes.GET_REPORT_COURSES_CLOSING, payload);
export const setReportCoursesClosing = (payload) =>
  action(ActionTypes.SET_REPORT_COURSES_CLOSING, payload);

export const getReportCoursesClosingCount = (payload) =>
  action(ActionTypes.GET_REPORT_COURSES_CLOSING_COUNT, payload);
export const setReportCoursesClosingCount = (payload) =>
  action(ActionTypes.SET_REPORT_COURSES_CLOSING_COUNT, payload);
export const getExcelCoursesClosing = (payload) =>
  action(ActionTypes.GET_EXCEL_COURSES_CLOSING, payload);

export const getSociedadesCursosCierres = (payload) =>
  action(ActionTypes.GET_SOCIEDADES_CURSOS_CIERRES, payload);
export const setSociedadesCursosCierres = (payload) =>
  action(ActionTypes.SET_SOCIEDADES_CURSOS_CIERRES, payload);

export const getProvinciasCursosCierres = (payload) =>
  action(ActionTypes.GET_PROVINCIAS_CURSOS_CIERRES, payload);
export const setProvinciasCursosCierres = (payload) =>
  action(ActionTypes.SET_PROVINCIAS_CURSOS_CIERRES, payload);
export const removeCursosCierreFilter = () =>
  action(ActionTypes.REMOVE_CURSOS_CIERRES_FILTER);

// Caché
export const setAllSociedades = (payload) =>
  action(ActionTypes.SET_ALL_SOCIEDADES, payload);

//panel administracion
//panel gestor
export const getAllGestores = () =>
  action(ActionTypes.GET_ALL_GESTORES);
export const setAllGestores = (payload) =>
  action(ActionTypes.SET_ALL_GESTORES, payload);
export const setGetAllGestoresRequestStatus = (payload) =>
  action(ActionTypes.SET_GET_ALL_GESTORES_REQUEST_STATUS, payload);

export const insertarGestoresCursos = (payload) =>
  action(ActionTypes.INSERTAR_GESTORES_CURSOS, payload);
export const setInsertarGestoresCursoRequestStatus = (payload) =>
  action(ActionTypes.SET_INSERTAR_GESTORES_CURSOS_REQUEST_STATUS, payload);

export const eliminarGestoresCursos = (payload) =>
  action(ActionTypes.ELIMINAR_GESTORES_CURSOS, payload);
export const setEliminarGestoresCursoRequestStatus = (payload) =>
  action(ActionTypes.SET_ELIMINAR_GESTORES_CURSOS_REQUEST_STATUS, payload);




//panel formador
export const getAllFormadores = () =>
  action(ActionTypes.GET_ALL_FORMADORES);
export const setAllFormadores = (payload) =>
  action(ActionTypes.SET_ALL_FORMADORES, payload);
export const setGetAllFormadoresRequestStatus = (payload) =>
  action(ActionTypes.SET_GET_ALL_FORMADORES_REQUEST_STATUS, payload);

export const insertarFormadoresCursos = (payload) =>
  action(ActionTypes.INSERTAR_FORMADORES_CURSOS, payload);
export const setInsertarFormadoresCursoRequestStatus = (payload) =>
  action(ActionTypes.SET_INSERTAR_FORMADORES_CURSOS_REQUEST_STATUS, payload);

export const eliminarFormadoresCursos = (payload) =>
  action(ActionTypes.ELIMINAR_FORMADORES_CURSOS, payload);
export const setEliminarFormadoresCursoRequestStatus = (payload) =>
  action(ActionTypes.SET_ELIMINAR_FORMADORES_CURSOS_REQUEST_STATUS, payload);




//panel alumno
export const getAllAlumnos = () =>
  action(ActionTypes.GET_ALL_ALUMNOS);
export const setAllAlumnos = (payload) =>
  action(ActionTypes.SET_ALL_ALUMNOS, payload);
export const setGetAllAlumnosRequestStatus = (payload) =>
  action(ActionTypes.SET_GET_ALL_ALUMNOS_REQUEST_STATUS, payload);

export const insertarAlumnosCursos = (payload) =>
  action(ActionTypes.INSERTAR_ALUMNOS_CURSOS, payload);
export const setInsertarAlumnosCursoRequestStatus = (payload) =>
  action(ActionTypes.SET_INSERTAR_ALUMNOS_CURSOS_REQUEST_STATUS, payload);

export const eliminarAlumnosCursos = (payload) =>
  action(ActionTypes.ELIMINAR_ALUMNOS_CURSOS, payload);
export const setEliminarAlumnosCursoRequestStatus = (payload) =>
  action(ActionTypes.SET_ELIMINAR_ALUMNOS_CURSOS_REQUEST_STATUS, payload);

